import React from "react";
import styled from "styled-components";
import { compose } from "redux";
import { withRouter } from "react-router";
import { Typography } from "@material-ui/core";
import { ButtonText, InputText, InputSwitch } from "@loanbossinc/component-library";
import { Search } from "@material-ui/icons";
import { LENDER_REPORTING_SETTINGS } from "constants/routes";

import { Calendar } from "./calendar";

const CommonStyle = `
  display: flex;
  width: 100%;
`;

const CalendarWrapper = styled.div`
  margin-left: 75px;
  padding: 7px 0px 0px 40px;
`;

const FilterWrapper = styled.div`
  padding: 7px 0px 0px 40px;
  & button {
    width: 100px !important;
  }
`;

const SearchBarWrapper = styled.div`
  justify-content: space-between;
  text-align: left;
  width: 75%;
`;

const SettingsWrapper = styled.div`
  justify-content: flex-start;
  margin-left: 20x;
  text-align: left;
  width: 50%;
`;

const SettingsSectionContainer = styled.div`
  ${CommonStyle}
  justify-content: space-between;
`;

const StyledHeaderSectionContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 2em;
  justify-content: center;
  padding: 2em;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #dadce0;
`;

const StyledInput = styled(ButtonText)`
  float: left;
  width: 50%;
`;

const StyledInputText = styled(InputText)`
  && {
    width: 605px;
    && > div {
      background-color: #ffffff;
      border-radius: 8px;
      font-family: Work Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      overflow: hidden;
    }
    && > div > svg {
      margin-right: 0.5em;
    }
  }
`;

const StyledSettingsButtonText = styled(ButtonText)`
  &&& {
    display: flex;
    height: auto;
    margin-left: 15px;
    place-content: space-around;
    width: 145px;
  }
`;

const StyledSwitch = styled(InputSwitch)`
  & .Mui-checked {
    color: #2c98f0 !important;
  }
`;

const Title = styled.div`
  font-family: Work Sans;
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  padding-top: 3px;
`;

const TitleAndSettingsSectionContainer = styled.div`
  ${CommonStyle}
  justify-content: flex-start;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
  padding: 0 1em;
  box-sizing: border-box;
`;

const HeaderComponent = ({
  history,
  isAdmin,
  isReportGroupsLoading,
  reportGroupInstances,
  selectedDate,
  setSearchText,
  setSelectedDate,
  toggleDrawer,
  showCalendarFilter,
  toggleCalendarFilter
}) => (
  <StyledHeaderSectionContainer>
    <TitleSection>
      {!isReportGroupsLoading && (
        <TitleAndSettingsSectionContainer>
          <Title>Lender Compliance Reports</Title>
          <SettingsWrapper>
            {isAdmin && <StyledSettingsButtonText label="User permissions" onClick={() => history.push(LENDER_REPORTING_SETTINGS)} />}
          </SettingsWrapper>
        </TitleAndSettingsSectionContainer>
      )}
      {!isReportGroupsLoading && (
        <SettingsSectionContainer>
          <SearchBarWrapper>
            <StyledInputText
              InputProps={{ startAdornment: <Search /> }}
              borderRadius={8}
              onChange={e => setSearchText(e.target.value)}
              placeholder="Filter reports by deal name"
              type="search"
              variant="outlined"
            />
          </SearchBarWrapper>
          <CalendarWrapper>
            <StyledSwitch
              label={<Typography style={{ fontSize: 16, fontFamily: "Work Sans", color: "#5F6368", fontWeight: 500 }}>Calendar</Typography>}
              value={showCalendarFilter}
              onChange={toggleCalendarFilter}
            />
          </CalendarWrapper>
          <FilterWrapper>
            <StyledInput label="Filters" iconName="tune" onClick={toggleDrawer} />
          </FilterWrapper>
        </SettingsSectionContainer>
      )}
    </TitleSection>
    {!isReportGroupsLoading && showCalendarFilter && (
      <Calendar reportGroupInstances={reportGroupInstances} selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
    )}
  </StyledHeaderSectionContainer>
);
export default compose(withRouter)(HeaderComponent);
